// Password Toggle - kurun.tokyo
document.addEventListener('DOMContentLoaded', function () {
  var toggleBtn = document.querySelector('.krt-password-toggle');
  if (!toggleBtn) return;

  toggleBtn.addEventListener('click', function () {
    var wrapper = this.closest('.krt-password-wrapper');
    if (!wrapper) return;

    var input = wrapper.querySelector('input');
    if (!input) return;

    var eyeShow = this.querySelector('.krt-eye-show');
    var eyeHide = this.querySelector('.krt-eye-hide');

    if (input.type === 'password') {
      input.type = 'text';
      if (eyeShow) eyeShow.style.display = 'none';
      if (eyeHide) eyeHide.style.display = 'block';
      this.setAttribute('aria-label', 'パスワードを非表示');
      this.setAttribute('aria-pressed', 'true');
    } else {
      input.type = 'password';
      if (eyeShow) eyeShow.style.display = 'block';
      if (eyeHide) eyeHide.style.display = 'none';
      this.setAttribute('aria-label', 'パスワードを表示');
      this.setAttribute('aria-pressed', 'false');
    }
  });
});

